import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faKey, faArrowRight, faGear, faBarsStaggered, faCloudArrowDown} from '@fortawesome/free-solid-svg-icons'

library.add(faUser, faKey, faArrowRight, faGear, faBarsStaggered, faCloudArrowDown)